export const alertText =
  'При запросах на формирование отчета об израсходованных драгоценных металлах необходимо учитывать, что корректная информация формируется только за закрытый бухгалтерский период (не ранее 10го числа месяца следующего за запрашиваемым). При формировании отчета за неполный/незакрытый период возможно отражение корректировок в цифрах отчета.';

export const MODAL_METAL_REPORT = 'metal-report-request';
export const MODAL_METAL_REPORT_SUCCESS = `${MODAL_METAL_REPORT}-success`;
